import { render, staticRenderFns } from "./InsurerEntity.vue?vue&type=template&id=316cfd2c&scoped=true"
import script from "./InsurerEntity.vue?vue&type=script&lang=js"
export * from "./InsurerEntity.vue?vue&type=script&lang=js"
import style0 from "./InsurerEntity.vue?vue&type=style&index=0&id=316cfd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316cfd2c",
  null
  
)

export default component.exports